import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {
  public urlImagem = "../../../assets/img/logo-nalenha.png";
  public tituloImagem = "NaLenha Pizzaria";
}
